import { useSearchParams } from 'react-router-dom';
import Issues from '../components/Issues/Issues';

const IssuesScreen = () => (
    <Issues />
);

export default IssuesScreen;
